export default __webpack_public_path__ + "static/media/minivistaw-mineria.f6fa3b79.jpg";